/*
 * @Author       : panyangyang
 * @Date         : 2026-02-05 16:14:03
 * @LastEditTime : 2026-02-10 09:15:30
 * @LastEditors  : panyangyang
 * @Description  : 供应商管理api
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\supplierList.js
 */
import request from '../request.js'

// 供应商管理-分页列表 ---- 朱新宇
export const selectSuppliersPage = function(data) {
	return request({
		url: '/ngsOrder/selectSuppliersPage',
		method: 'post',
		data
	})
}

// 供应商管理-保存 ---- 朱新宇
export const saveSuppliers = function(data) {
	return request({
		url: '/ngsOrder/saveSuppliers',
		method: 'post',
		data
	})
}

// 供应商管理-详情 ---- 朱新宇
export const getSuppliersDetail = function(data) {
	return request({
		url: '/ngsOrder/getSuppliersDetail',
		method: 'post',
		data
	})
}

// 供应商管理-删除 ---- 朱新宇
export const delSuppliers = function(data) {
	return request({
		url: '/ngsOrder/delSuppliers',
		method: 'post',
		data
	})
}

// 供应商管理-关联商品分页 ---- 朱新宇
export const getRelateGoodsPage = function(data) {
	return request({
		url: '/ngsOrder/getRelateGoodsPage',
		method: 'post',
		data
	})
}

// 商品管理弹框-查询供应商 ---- 朱新宇
export const selectSuppliers = function(data) {
	return request({
		url: '/ngsOrder/selectSuppliers',
		method: 'post',
		data
	})
}
